import classNames from 'classnames';
import { t } from 'ttag';
import { generatePath } from 'react-router-dom';

import MenuIcon from '@svg/menu.svg';
import UaFlag from '@svg/ua-flag.svg';
import MilitaryIcon from '@svg/military.svg';
import DiscountIcon from '@svg/discount.svg';
import CraftaIcon from '@svg/crafta.svg';
import * as path from '@urls';
import { LocalizedLink } from '@ui/LocalizedLink';
import { Button } from '@ui/Button';
import { LinkProps } from '@ui/Link';

import s from './SecondaryHeaderDesktop.sss';

interface NavItem {
  name: React.ReactElement | string,
  href: string,
  theme?: LinkProps['theme'],
  className?: string,
}

const getLinks = (): NavItem[] => ([
  {
    name: (
      <>
        <DiscountIcon
          className={s.icon}
          width={24}
          height={24}
        />
        {t`Знижки`}
      </>
    ),
    href: path.dayDiscount,
    className: s.linkThemePink,
  },
  {
    name: (
      <>
        <CraftaIcon
          className={s.icon}
          width={18}
        />
        {t`Хендмейд`}
      </>
    ),
    href: generatePath(path.collections, { slug: 'craft-goods' }),
  },
  {
    name: (
      <>
        <UaFlag
          className={s.icon}
          width={24}
          height={24}
        />
        {t`Зроблено в Україні`}
      </>
    ),
    href: generatePath(path.collections, { slug: 'made-in-ukraine' }),
  },
  {
    name: (
      <>
        <MilitaryIcon
          className={s.icon}
          width={24}
          height={24}
        />
        {t`Для захисників`}
      </>
    ),
    href: generatePath(path.collections, { slug: 'dlya-viyskovih' }),
  },
  {
    name: t`Новинки`,
    href: path.newArrivals,
  },
  {
    name: t`Стрічка`,
    href: path.socialFeed,
    className: s.linkThemePurple,
  },
]);

export interface CatalogTree {
  id: number,
  name: string,
  slug: string,
  subCatalogs: CatalogTree[],
}

interface Props {
  className?: string,
  catalogName?: string | null,
  isMenuOpen: boolean,
  onMenuToggle: () => void,
}

export const SecondaryHeaderDesktop: React.FC<Props> = ({
  className,
  catalogName,
  isMenuOpen,
  onMenuToggle,
}) => (
  <ul className={classNames(s.list, className)}>
    <li className={s.item}>
      <Button
        theme='text'
        className={classNames(s.menuButton, { [s.menuButtonStateActive]: isMenuOpen })}
        onClick={(e) => {
          e.stopPropagation();
          onMenuToggle();
        }}
      >
        <MenuIcon
          className={s.menuIcon}
          width='16'
          height='14'
        />
        {catalogName || t`Каталог`}
      </Button>
    </li>

    {getLinks().map((item, i) => (
      <li
        key={i}
        className={s.item}
      >
        <LocalizedLink
          className={classNames(s.link, item.className)}
          href={item.href}
          theme={item.theme || 'clean'}
        >
          {item.name}
        </LocalizedLink>
      </li>
    ))}
  </ul>
);
